import { createStore } from '@store/createStore';

const useHODetailsStore = createStore(
  (set) => ({
    searchValue: '',
    openedKeys: {},
    lastViewedId: null,

    actions: {
      setHODetailsStoreSearchValue: (searchValue) => set({ searchValue }),
      setHODetailsLastViewedId: (lastViewedId) => set({ lastViewedId }),
      setHODetailsOpenedKeys: (key, value) =>
        set(({ openedKeys }) => {
          return { openedKeys: { ...openedKeys, [key]: value } };
        }),
    },
  }),
  'HODetailsStoreStore',
);

export const useHODetailsActions = () => useHODetailsStore((state) => state.actions);

export const selectHODetailsSearchValue = () => useHODetailsStore((state) => state.searchValue);
export const selectHODetailsLastViewedId = () => useHODetailsStore((state) => state.lastViewedId);
export const selectHODetailsOpenedKeys = () => useHODetailsStore((state) => state.openedKeys);
